import { module } from 'modujs';
import { lerp } from '../utils/maths'

const LERP_FACTOR = 0.02

export default class extends module {
    constructor(m) {
        super(m);

        this.target = {
            x: 0,
            y: 0
        }

        this.transform = {
            x: 0,
            y: 0
        }

        this.followCursor = false;
    }

    init() {
        this.visual = this.$('visual')[0]

        if (this.visual && window.getComputedStyle(this.visual).position === 'absolute') {
            this.followCursor = true;

            this.mouseenterBind = () => {
                this.computeVisual()
            }
            this.el.addEventListener('mouseenter', this.mouseenterBind)

            this.mousemoveBind = (e) => {
                const X = (e.pageX - this.elOffset.left)
                const Y = (e.pageY - this.elOffset.top)

                this.target.x = (X - this.visualOrigins.left)
                this.target.y = (Y - this.visualOrigins.top)
            }
            this.el.addEventListener('mousemove', this.mousemoveBind)

            this.mouseleaveBind = () => {
                this.target.x = 0
                this.target.y = 0
            }
            this.el.addEventListener('mouseleave', this.mouseleaveBind)

            this.updateVisual()
        }

        this.btn = this.$('btn')[0]

        if (this.btn) {
            this.onBtnHover = () => {
                this.el.classList.add('-hover')
            }
            this.btn.addEventListener('mouseenter', this.onBtnHover)
            this.btn.addEventListener('focus', this.onBtnHover)

            this.onBtnLeave = () => {
                this.el.classList.remove('-hover')
            }
            this.btn.addEventListener('mouseleave', this.onBtnLeave)
            this.btn.addEventListener('blur', this.onBtnLeave)
        }
    }

    computeVisual() {
        if (!this.followCursor) {
            return;
        }

        this.visualOrigins = {
            top:  (this.visual.offsetTop + this.visual.offsetHeight / 2),
            left: (this.visual.offsetLeft + this.visual.offsetWidth / 2),
        }

        this.elOffset = {
            top:  this.el.offsetTop,
            left: this.el.offsetLeft,
        }
    }

    updateVisual() {
        if (!this.followCursor) {
            return;
        }

        this.transform.x = lerp(this.transform.x, this.target.x, LERP_FACTOR)
        this.transform.y = lerp(this.transform.y, this.target.y, LERP_FACTOR)

        this.visual.style.transform = `translate3d(${this.transform.x}px, ${this.transform.y}px, 0)`

        this.raf = requestAnimationFrame(this.updateVisual.bind(this))
    }

    destroy() {
        if (this.raf) {
            cancelAnimationFrame(this.raf)
        }

        if (this.followCursor) {
            this.el.removeEventListener('mouseenter', this.mouseenterBind)
            this.el.removeEventListener('mousemove', this.mousemoveBind)
            this.el.removeEventListener('mouseleave', this.mouseleaveBind)
        }

        if (this.btn) {
            this.btn.removeEventListener('mouseenter', this.onBtnHover)
            this.btn.removeEventListener('focus', this.onBtnHover)
            this.btn.removeEventListener('mouseleave', this.onBtnLeave)
            this.btn.removeEventListener('blur', this.onBtnLeave)
        }
    }
}
